<template>
  <div class="row offer-filter pad-top">
    <div class="col-md-12">
      <MultiSelect track-by="name" v-model="Storage.webAddTagFilter" :multiple="true"
                :placeholder="$t('statistic.webmaster')" label="name"
               :disabled="disabled" ref="multiselect" :options="options" :taggable="true" @tag="addTag">
      </MultiSelect>
    </div>
  </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import Storage from '../../api/Storage'

  export default {
    name: 'WebmasterFilter',
    components: {
      MultiSelect
    },
    props: {
      disabled: {
        type: Boolean,
        required: true
      }
    },
    mounted () {

    },
    data () {
      return {
        Storage: Storage,
        options: []
      }
    },
    methods: {
      addTag (newTag) {
        if (Storage.webAddTagFilter == null) {
          Storage.webAddTagFilter = []
        }
        const tag = {
          name: newTag
        }
        this.options.push(tag)
        Storage.webAddTagFilter.push(tag)
      }
    }
  }
</script>

<style>
.pad-top{
  padding-top:5px; 
}
</style>



// WEBPACK FOOTER //
// WebmasterFilter.vue?4e18cf82